export const GET_LIST_DONGTIENNHANH = "GET_LIST_DONGTIENNHANH";
export const GET_LIST_DONGTIENNHANH_SUCCESS = "GET_LIST_DONGTIENNHANH_SUCCESS";
export const GET_LIST_DONGTIENNHANH_FAILURE = "GET_LIST_DONGTIENNHANH_FAILURE";
